export default [
	{
		path: '/account/login',
		name: 'AccountLogin',
		component: () => import('@/views/account/login.vue'),
		meta: { title: '登录页' }
	},
	{
		path: '/personal/personal',
		name: 'Personal',
		component: () => import('@/views/personal/personal.vue'),
		meta: { title: '个人中心' }
	},
]
